import { Mediator } from '../modules/mediator/mediator.js';
import 'project/css/main.css';
import html2pdf from 'html2pdf.js';

// Hacer html2pdf disponible globalmente
window.html2pdf = html2pdf;

const mediator = new Mediator();
mediator.init();
